import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { EMPTY_DEFAULT_REPORT } from './reportsConfiguration';
import { CUSTOM_DASHBOARD_INTERNAL_TYPES } from '@linearb/linjs-common';

const shouldOpenAddReportMenu = (isCustomPmMetricsEnabled, isJiraProvider) => {
  return isCustomPmMetricsEnabled && isJiraProvider;
};

export const onDashboardTypeSelect = ({
  internalType,
  setNewCustomDashBoard,
  setAddDashboardAnchorEl,
  generateNewReport,
  history,
  setSelectedReport,
  match
}) => {
  setAddDashboardAnchorEl(null);
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.METRICS,
    click_type: TRACKING.CLICK.NEW_CUSTOM_DASHBOARD,
    dashboard_type: internalType
  });
  const newReport = generateNewReport();
  if (internalType === CUSTOM_DASHBOARD_INTERNAL_TYPES.CUSTOM_PM_METRICS) {
    addDashboard({
      newReport: { ...newReport, internal_type: internalType },
      setNewCustomDashBoard,
      setSelectedReport,
      history,
      match
    });
    return;
  }
  addDashboard({
    newReport,
    setNewCustomDashBoard,
    setSelectedReport,
    history,
    match
  });
};

export const onAddReport = ({
  event,
  isCustomPmMetricsEnabled,
  setAddDashboardAnchorEl,
  generateNewReport,
  setNewCustomDashBoard,
  setSelectedReport,
  history,
  match,
  isJiraProvider
}) => {
  const shouldOpenMenu = shouldOpenAddReportMenu(
    isCustomPmMetricsEnabled,
    isJiraProvider
  );
  if (shouldOpenMenu) {
    setAddDashboardAnchorEl(event.currentTarget);
    return;
  }
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.METRICS,
    click_type: TRACKING.CLICK.NEW_CUSTOM_DASHBOARD
  });
  addDashboard({
    newReport: generateNewReport(),
    setNewCustomDashBoard,
    setSelectedReport,
    history,
    match
  });
};

const addDashboard = ({
  newReport,
  setNewCustomDashBoard,
  setSelectedReport,
  history,
  match
}) => {
  setNewCustomDashBoard(newReport);
  setSelectedReport(null);
  history.push({
    pathname: `${match.path}/${EMPTY_DEFAULT_REPORT.id}`,
    search: history.location.search
  });
};

export const calculateEllipsisAfter = containerWidth => {
  return `${containerWidth / 14}rem`;
};
